import React, { useState, useEffect, useRef, useContext } from 'react'
import queryString from 'query-string'
import Axios from 'axios'
import moment from 'moment'
import {
  TextEditor,
  getContent,
  isContentChanged,
  resetIsContentChanged,
  isUndoEmpty,
  isRedoEmpty,
  handleRedo as onRedo,
  handleUndo as onUndo,
} from '../../../../components/TextEditor'
import { get, post, put } from '../../../../lib/api'
import SaveIcon from '../../../../components/Images/Save'
import { Revisions } from '../../../../components/TextEditor/revisions'
import Loader from '../../../../components/Loader'
import GenericError from '../../../../components/GenericError'
import AlertSnackBar from '../../../../components/AlertSnackBar'
import PrivatePage, { menuItemObj } from '../../../../components/PrivatePage'
import { Provider } from '../../../../context/editorContext'
import './chapterAddEdit.css'
import { EditorControls } from '../Edit/chapterEditor'
import {
  handleEventLog,
  handlePageLoadEventLog,
  removeSpecialCharacters,
  waitForSomeTime,
  getWordCountFromVariant,
  extractChapterSequenceUsingSplit,
  changeUrlWithoutReload
} from '../../../../lib/utils'
import { months } from '../../../../constants'
import './chapterAddEdit.css'
import { getPlainContent } from '../../../../components/TextEditor/TinyMCEEditor'
import ChapterScheduler from '../ChapterScheduler'
import {
  get as getFromLocal,
  set as setToLocal,
} from '../../../../lib/storage/index'
import PostPublishScreen from './PostPublishScreen'
import VerifyForBadPublish from './PopupsInChapterAddEdit/VerifyForBadPublish'
import HasUnsavedChanges from './PopupsInChapterAddEdit/HasUnsavedChanges'
import RestrictDelete from './PopupsInChapterAddEdit/RestrictDelete'
import WarningPopup from './PopupsInChapterAddEdit/WarningPopup'
import { AccountContext } from '../../../../providers/accountProvider'
import PostPublishScreenVariantB from './PostPublishScreenVariantB'
import VoiceSelection from './VoiceSelection'
import { handleNewEventLog } from '../../../../lib/utils/events'
import IncentiveGoalBox from './IncentiveGoalBox'
import { EditorPageMainDiv, IncentiveWrapper } from './styles'
import StoryConfirmPublishPopup from './PopupsInChapterAddEdit/StoryConfirmPublishPopup'

export default function ChapterAddEdit(props) {
  const {
    history,
    match: {
      params: { id, action },
    },
    location: { search },
  } = props
  const qParams = queryString.parse(search)
  const { proceed_to_details, redirect_to_home, redirect_to_novel } = qParams

  const [chapter_id, setChapter_id] = useState(
    queryString.parse(search).chapter_id
  )
  const auto_save_enabled_ref = useRef(false)
  const is_published_ref = useRef(false)
  const latest_chapter_details = useRef()
  const latest_word_count = useRef(0)
  const title_changed_ref = useRef(false)
  const chapterCount = queryString.parse(search).count || 0
  const { tab } = queryString.parse(search)
  const [content, setContent] = useState('')
  const [wordCount, setWordCount] = useState(0)
  const [editorState, setEditorState] = useState(null)
  const [title, setTitle] = useState('')
  const [emptyTitleError, setEmptyTitleError] = useState(false)
  const [showVersion, toggleShowVersion] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [chapterDetails, setChapterDetails] = useState()
  const [apiError, toggleApiError] = useState(false)
  const title_ref = useRef('Untitled Chapter')
  const [isNavMenuOpen, setNavMenuOpen] = useState(false)
  const submitting_ref = useRef(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [savedChanges, setSavedChanges] = useState(false)
  const [warningPopup, setWarningPopup] = useState(false)
  const [isBack, setIsBack] = useState(false)
  const [alertText, setAlertText] = useState('')
  const [alertStyle, setAlertStyle] = useState({})
  const [userCalendarDate, setUserCalendarDate] = useState('')
  const [hasPublishWarning, setHasPublishWarning] = useState(false)
  const [novelDetails, updateNovelDetails] = useState({})
  const [restrictDelete, setRestrictDelete] = useState(false)
  const [schedulerPopup, toggleSchedulerPopup] = useState(false)
  const [confirmStoryPopup, toggleConfirmStoryPopup] = useState(false)
  const [showPostPublishScreen, togglePostPublishScreen] = useState(false)
  const [showVoiceSelectionPopup, toggleVoiceSelectionPopup] = useState(false)
  const [showBackgroundMusicPopup, toggleBackgroundMusicPopup] = useState(false)
   const [showSharePopUpOpen, setShowSharePopupOpen] = useState(false);
  const [showShareNotification, setShowShareNotification] = useState(false)
  const [showPostPublishData, setPostPublishData] = useState(null)
  const [audioSelction, updateAudioSelection] = useState(null)
  const [wordLimit, setWordLimit] = useState(1000)
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [fileURL, setFileURL] = useState(null)
  const [verifyForBadPublish, setVerifyForBadPublish] = useState({
    show: false,
  })
  const isMounted = useRef(false)
  const { user, isUgcUser, isHindiUgcUser } = useContext(AccountContext)
  const searchParams = new URLSearchParams(history.location.search)
  const referrer = searchParams.get('referrer')

  const [onWordCountThresholdCrossed, setOnWordCountThresholdCrossed] =
    useState({
      1: false,
      100: false,
      250: false,
      500: false,
      750: false,
      1000: false,
      1500: false,
      2000: false,
      2500: false,
    })
  const thresholds = [1, 100, 250, 500, 750, 1000, 1500, 2000, 2500]

  const pushToNovelForm =
    (isUgcUser || isHindiUgcUser) &&
    novelDetails?.is_novel === 2 &&
    wordCount + novelDetails?.word_count >= 10000 &&
    !novelDetails?.trope_info?.length &&
    !novelDetails?.maturity_rating
  const process = sessionStorage.getItem('process')

  const fetchNovelDetails = async () => {
    const params = {
      // uid: localStorage.getItem('uid'),
      book_id: props.match.params.id,
      req_author: 1,
      view: 'writers',
      is_novel: 1,
    }
    await get('/content_api/book.novel_details', { params: params }).then(
      (response) => {
        response = response.results
        if (response?.auto_save_enabled) {
          auto_save_enabled_ref.current = true
        }
        handleNewEventLog(
          'chapter_editor',
          response?.is_novel === 3 ? 'stories_editor_screen_viewed' : 'novels_chapter_editor_viewed',
          {
            route: window.location.pathname + window.location.search,
            module_name: 'chapter_editor',
            entity_id: chapter_id || 'Null',
            entity_type: 'chapter',
          },
          user,
          response
        )
        if (!chapter_id) {
          setWordLimit(
            response?.is_novel === 3 ? 250 :
            getWordCountFromVariant(
              response?.boosting_word_count_exp_variant,
              parseInt(chapterCount) + 1
            )
          )
        } else {
          fetchChapterDetails(response)
        }
        updateNovelDetails(response)
        if (!chapter_id && response?.is_novel === 2) {
          setTitle('')
          title_ref.current = ''
        }
      }
    )
  }

  useEffect(() => {
    let timer
    if (showShareNotification) {
      timer = setTimeout(() => {
        setShowShareNotification(false)
      }, 3000)
    }
    return () => clearTimeout(timer)
  }, [showShareNotification])

  useEffect(() => {
    handlePageLoadEventLog('edit_chapter')
    if (
      window.Android &&
      (process === 'continue-writing' || process === 'create-new')
    ) {
      if (window.Android.closeContinueWriting) {
        console.log('Executed closeContinueWriting()')
        window.Android.closeContinueWriting()
      }
    }
    let autoSaveInterval
    const loadChapterData = async () => {
      handlePageLoadEventLog('edit_chapter')
      await fetchNovelDetails()
      let currentContent = content
      if (chapter_id) {
        const { data } = await fetchChapterDetails()
        currentContent = data
      }
      if (latest_chapter_details.current?.result?.status !== 'published' && auto_save_enabled_ref.current) {
        autoSaveInterval = setInterval(() => {
          let typedContent = getContent(editorState)
          if (
            typedContent !== currentContent &&
            !submitting_ref.current &&
            latest_word_count.current !== 0 && 
            !is_published_ref.current
          ) {
            setIsSubmitting(true)
            submitting_ref.current = true
            uploadFile({ status: 'draft_auto_saved', flow: 'draft' })
            currentContent = typedContent
          }
        }, 30000)
      }
    }
    loadChapterData()

    return () => {
      isMounted.current = true
      clearInterval(autoSaveInterval)
    }
  }, [])

  const getChapterObject = () =>
    chapter_id ? JSON.parse(getFromLocal('autosave'))?.[chapter_id] : null

  useEffect(() => {
    if (isContentChanged(editorState)) {
      if (chapter_id) {
        const content = getContent(editorState)
        const chapterObject = getChapterObject()
        if (chapterObject && chapterObject.fileURL === fileURL)
          setChapterObject({ chapterId: chapter_id, fileURL, content })
        else setChapterObject({ chapterId: chapter_id, fileURL, content })
      }
    }
    return () => {}
  })

  const handlePublishChapterWithVoice = (chapterId, url, isNewVersion) => {
    if (!novelDetails?.show_id) {
      console.log('no show id')
      return
    }
    const convertAudioData = {
      show_id: novelDetails?.show_id,
      chapter_id: chapterId,
      script_url: url,
      regeneration_required: isNewVersion ? true : false,
    }
    if (!novelDetails?.ugc_show_configured) {
      if (!audioSelction) return
      const { voice_selection, background_music } = audioSelction
      const voiceData = {
        voice_id: voice_selection?.voice_id,
        show_id: novelDetails?.show_id,
        mastering_genre: background_music?.key,
        mastering_required: true,
        vendor: 'eleven_labs',
        voice_name: voice_selection?.name,
      }
      post(`/content_api/ugc/audio/configure_ugc_show/`, {
        data: voiceData,
      }).then((res) => {
        console.log('configure ugc show', res)
        post(`/content_api/ugc/audio/convert_to_audio/`, {
          data: convertAudioData,
        }).then((result) => {
          console.log('converted Audio Result ', result)
        })
      })
    } else {
      post(`/content_api/ugc/audio/convert_to_audio/`, {
        data: convertAudioData,
      }).then((result) => {
        console.log('converted Audio Result ', result)
      })
    }
  }

  const handlePublishLog = (startTime, chapterId) => {
    const now = new Date()
    const endTime = now.getTime()
    const timeDiff = (endTime - startTime) / 1000
    handleEventLog('edit_chapter', 'publish_request_duration', {
      time: timeDiff,
      route: window.location.pathname + window.location.search,
      entity_type: 'chapter',
      entity_id: chapterId,
    })
  }

  const setChapterObject = (chapterObj) => {
    const chaptersObject = JSON.parse(getFromLocal('autosave')) ?? {}
    chaptersObject[chapterObj.chapterId] = chapterObj
    setToLocal('autosave', JSON.stringify(chaptersObject))
  }

  const checkUnsavedChanges = (fileURL, content) => {
    if (chapter_id) {
      const chapterObject = getChapterObject()
      if (
        chapterObject &&
        chapterObject.content &&
        chapterObject.content !== content &&
        chapterObject.fileURL === fileURL
      ) {
        setHasUnsavedChanges(true)
      } else setChapterObject({ chapterId: chapter_id, fileURL, content })
    }
  }

  const fetchChapterDetails = async (bookData) => {
    setLoading(true)
    try {
      const chp_details = await get('/content_api/book.get_chapter_details', {
        params: {
          chapter_id,
          book_id: id,
          view: 'writers',
          is_novel: 1,
        },
      })
      setChapterDetails(chp_details)
      latest_chapter_details.current = chp_details
      const { result } = chp_details
      const { file_url, chapter_title, status } = result
      if (!status?.includes('draft')) {
        setWordLimit(
          novelDetails?.is_novel === 3 ? 250 :
          getWordCountFromVariant(
            novelDetails?.boosting_word_count_exp_variant,
            extractChapterSequenceUsingSplit(chapter_title)
          )
        )
      } else if (bookData) {
        setWordLimit(
          bookData?.is_novel === 3 ? 250 :
          getWordCountFromVariant(
            bookData?.boosting_word_count_exp_variant,
            parseInt(bookData?.chapter_count || 0) + 1
          )
        )
      }
      setFileURL(file_url)
      const text = await Axios.get(file_url)
      if (chapter_title === 'Untitled Chapter') {
        setTitle('')
      } else {
        setTitle(chapter_title)
      }
      title_ref.current = chapter_title
      setContent(text.data)
      checkUnsavedChanges(file_url, text.data)
      setLoading(false)
      return { data: text.data, status }
    } catch (error) {
      props.history.goBack()
      setIsBack(true)
      setLoading(false)
      throw error
    }
  }

  useEffect(() => {
    if (content) setLoading(false)
  }, [content])
  // useEffect(() => {
  //   if (title && content) setLoading(false)
  // }, [title, content])

  const updateState = (editor) => {
    setEditorState(editor)
  }

  const repeatedWordsCount = () => {
    let getContentText = getPlainContent()
    getContentText = removeSpecialCharacters(getContentText)
    if (getContentText.length < 1) return 0
    const words = getContentText.split(' ')
    const wordMap = {}
    let totalRepeatedWords = 0
    for (let i = 0; i < words.length; i += 1) {
      const currentWordCount = wordMap[words[i]]
      const count = currentWordCount ? currentWordCount : 0
      wordMap[words[i]] = count + 1
    }
    for (const val in wordMap) {
      if (wordMap[val] > 1) {
        totalRepeatedWords += wordMap[val] - 1
      }
    }
    return totalRepeatedWords
  }

  const handleBackForPostPublishScreen = () => {
    history.replace(`/shows/novels/id/${id}?tab=published`)
    setIsBack(true)
  }

  const checkIfWordCountIsZero = () => {
    if (!wordCount) {
      Promise.reject({ message: 'Word Count cannot be 0' })
      return true
    }
  }

  const handleVerificationPopup = async (resp) => {
    // this function allows to wait for the user's response in popup
    return new Promise((resolve, reject) => {
      setVerifyForBadPublish({
        show: true,
        loading: false,
        issue_type: resp?.issue,
        publish_anyway: resolve,
        review_again: resolve,
        words: resp?.problematic_words || [],
        message: resp?.message,
      })
    })
  }

  const VerifyChapter = async (details, status, url, latestVersion) => {
    if (
      (novelDetails?.verification_required === 'True' ||
        details?.seq_number == 1) &&
      status === 'review' &&
      details?.status !== 'published'
    ) {
      // if verification_required is true for the book
      setVerifyForBadPublish({ show: true, loading: true }) // open the popup to wait for verification and start loading
      try {
        let result = { message: 'Pending' }
        let maxApiCalls = 1
        while (
          (result?.message === 'Pending' || !result?.verified) &&
          !isMounted.current &&
          maxApiCalls < 11
        ) {
          const resp = await post(
            '/content_api/book.chapters/verify_chapter/?is_novel=1',
            {
              // calling the verification for bad content api
              data: {
                uid: localStorage.getItem('uid'),
                book_id: id,
                chapter_id: details.chapter_id,
                latest_version: latestVersion || details.latest_version,
                file_url: url || details?.file_url || fileURL,
                version_id: details.version_id,
                counter: maxApiCalls,
              },
            }
          )
          if (resp?.message !== 'Pending' && !resp?.verified) {
            setVerifyForBadPublish({ show: false, loading: false })
            return true
          }
          result = { ...resp }
          if (
            result?.post_publish_data &&
            result?.post_publish_data.length > 0
          ) {
            details.from_incentive_value =
              result?.post_publish_data[0]?.from_incentive_value
            details.to_incentive_value =
              result?.post_publish_data[0]?.to_incentive_value
            details.rem_streak_days =
              result?.post_publish_data[0]?.rem_streak_days
          }
          await waitForSomeTime(1000) // This function is to give time between api calls
          maxApiCalls += 1
        }
        if (result.verified && !result.issue_found) {
          setVerifyForBadPublish({ show: false, loading: false })
          return true
        } else if (result.verified && result.issue_found) {
          // if some issues are found
          handleNewEventLog(
            'chapter_editor',
            'novels_profane_chapter_publish_failed',
            {
              route: window.location.pathname + window.location.search,
              button: 'save_chapter',
              entity_id: chapter_id || 'Null',
              entity_type: 'chapter',
            },
            user,
            novelDetails
          )
          const userPopupResponse = await handleVerificationPopup(result)
          if (userPopupResponse === 'review_again') {
            // if response is review_again then only stop the flow
            toggleSchedulerPopup(false)
            return false
          } else {
            // else publish it by just changing the status
            const now = new Date()
            const startTime = now.getTime()
            const chapterData = {
              chapter_id: details.chapter_id,
              status: 'published',
              book_id: id,
              view: 'writers',
              program_type: novelDetails?.program_type || null,
            }
            if (userCalendarDate)
              chapterData.schedule_time = moment(
                `${userCalendarDate} 06:00 AM`
              ).format('YYYY-MM-DD HH:mm:ss')

            put('/content_api/book.update_chapter_status?is_novel=1', {
              data: chapterData,
            }).then((res) => {
              setAlertText('Published Successfully')
              setSavedChanges(true)
              handlePublishLog(startTime, details.chapter_id)
              setUserCalendarDate(userCalendarDate)
              if (!res?.results?.from_incentive_value) {
                if (redirect_to_novel) {
                  history.push(`${menuItemObj.novels}/id/${id}`)
                  return
                } else if (proceed_to_details) {
                  history.push(
                    `${
                      menuItemObj.novels
                    }/edit-novel-details/${id}?publish_chapter_id=${
                      details.chapter_id
                    }&redirect_to_home=${
                      redirect_to_home ? '1' : ''
                    }&first_publish=1`
                  )
                  return
                } else if (pushToNovelForm) {
                  history.push(`${menuItemObj.novels}/edit-novel-details/${id}`)
                  return
                }
                props.history.goBack()
              } else {
                details.from_incentive_value =
                  res?.results?.from_incentive_value
                details.to_incentive_value = res?.results?.to_incentive_value
                details.rem_streak_days = res?.results?.rem_streak_days
              }
            })
          }
        } else if (maxApiCalls === 11) {
          return true
        }
      } catch (error) {
        setVerifyForBadPublish({ show: false, loading: false })
        console.log(error)
        return true // even if the api fails for some reason we don't have to stop publishing chapter
      }
    }
    return true
  }

  const createChapterOrVersion = async (
    status,
    url,
    userCalendarDate,
    flow,
    saveMethod
  ) => {
    const repeated_words_count = repeatedWordsCount()
    if (latest_chapter_details.current?.result?.chapter_id) {
      // if we are dealing with already created chapter
      if (title_changed_ref.current) {
        const dataForVersion = {
          book_id: id,
          chapter_id: latest_chapter_details.current.result.chapter_id,
          word_count: latest_word_count.current,
          repeated_words_count,
          file_url: url,
          chapter_title: title_ref.current,
          status: status, // it is important to keep it draft for chapter name consitancy
          view: 'writers',
          program_type: novelDetails?.program_type || null,
        }
        if (userCalendarDate)
          dataForVersion.schedule_time = moment(
            `${userCalendarDate} 06:00 AM`
          ).format('YYYY-MM-DD HH:mm:ss')
        try {
          await post('/content_api/book.create_chapter?is_novel=1', {
            data: dataForVersion,
          })
        } catch (err) {
          if (status === 'draft_auto_saved') {
            setAlertText('Oops! Auto-save failed. Save your work manually')
            setAlertStyle({
              backgroundColor: '#FFE1E0',
              borderRadius: '50px',
              border: '1px solid #C1000066',
            })
          }
          if (novelDetails.content_editing && err.code === 400) {
            setRestrictDelete(true)
          } else throw err
        }
      }
      const dataForChapterVersion = {
        chapter_id: latest_chapter_details.current.result.chapter_id,
        word_count: latest_word_count.current,
        repeated_words_count,
        file_url: url,
        chapter_title: title_ref.current,
        book_id: id,
        view: 'writers',
        status: status,
      }

      if (userCalendarDate)
        dataForChapterVersion.schedule_time = moment(
          `${userCalendarDate} 06:00 AM`
        ).format('YYYY-MM-DD HH:mm:ss')
      post('/content_api/book.version?is_novel=1', {
        data: dataForChapterVersion,
      })
        .then(async (res) => {
          setIsSubmitting(false)
          resetIsContentChanged(false)
          let details = { ...latest_chapter_details.current.result, ...res }
          const isChapterSafe = await VerifyChapter(
            details,
            status,
            url,
            res.latest_version
          )
          if (!isChapterSafe) return
          if (flow === 'publish') {
            handlePublishChapterWithVoice(
              latest_chapter_details.current?.result?.chapter_id,
              url,
              true
            )
          }
          if (status === 'draft_auto_saved') {
            setAlertText('Content auto-saved! Keep writing')
          } else setAlertText('Updated Successfully')
          setAlertStyle({
            backgroundColor: '#E4F2E6',
            borderRadius: '50px',
            border: '1px solid #16A34A',
          })
          const now = new Date()
          const startTime = now.getTime()
          setSavedChanges(true)
          setIsBack(true)
          title_changed_ref.current = false
          submitting_ref.current = false
           if (
             novelDetails?.share_feature_variant === 'B' &&
             saveMethod === 'is_share_feature'
           ) {
             setShowSharePopupOpen(true);
           }

          // redirections
          if (proceed_to_details && flow === 'publish') {
            history.push(
              `${
                menuItemObj.novels
              }/edit-novel-details/${id}?publish_chapter_id=${chapter_id}&redirect_to_home=${
                redirect_to_home ? '1' : ''
              }`
            )
          }
          if (status !== 'draft' && status !== 'draft_auto_saved') {
            is_published_ref.current = true
            handlePublishLog(startTime, chapter_id)
            if (
              sessionStorage.getItem('campaign')?.includes('bingerinvite') ||
              process === 'create-new' ||
              process === 'continue-writing'
            ) {
              history.replace(`/shows/novels/id/${id}?tab=published`)
              return
            }
            if (pushToNovelForm) {
              history.push(`${menuItemObj.novels}/edit-novel-details/${id}`)
              return
            } else {
              if (details.from_incentive_value) {
                setPostPublishData({
                  from_incentive_value: details?.from_incentive_value || 0,
                  to_incentive_value: details?.to_incentive_value || 0,
                  rem_streak_days: details?.rem_streak_days || 0,
                  chapter_id: details?.chapter_id || '',
                  daily_bonus_word_count_cap_variant:
                    details?.daily_bonus_word_count_cap_variant || 'A',
                  isUgcBook:
                    novelDetails?.is_novel === 2 &&
                    novelDetails?.language === 'english',
                  words_cap: details?.words_cap || 2000,
                  today_word_count: details?.today_word_count || 0,
                  chapter_bonus: details?.chapter_bonus,
                })
                togglePostPublishScreen(true)
              } else history.replace(`/shows/novels/id/${id}?tab=published`)
            }
          }
        })
        .catch((err) => {
          submitting_ref.current = false
          if (status === 'draft_auto_saved') {
            setAlertText('Oops! Auto-save failed. Save your work manually')
            setAlertStyle({
              backgroundColor: '#FFE1E0',
              borderRadius: '50px',
              border: '1px solid #C1000066',
            })
          }
          setIsSubmitting(false)
          if (novelDetails.content_editing && err.code === 400) {
            setRestrictDelete(true)
          } else throw err
        })
    } else {
      // if we save or publish a new chapter
      const now = new Date()
      const startTime = now.getTime()
      const dataForChapter = {
        book_id: id,
        chapter_title: title_ref.current,
        file_url: url,
        word_count: latest_word_count.current,
        repeated_words_count,
        status: status,
        view: 'writers',
        program_type: novelDetails?.program_type || null,
      }
      setSavedChanges(true)
      if (userCalendarDate)
        dataForChapter.schedule_time = moment(
          `${userCalendarDate} 06:00 AM`
        ).format('YYYY-MM-DD HH:mm:ss')
      try {
        const res = await post('/content_api/book.create_chapter?is_novel=1', {
          data: dataForChapter,
        })
        setAlertText('Saved Successfully')
        setAlertStyle({
          backgroundColor: '#E4F2E6',
          borderRadius: '50px',
          border: '1px solid #16A34A',
        })
        // setDeclarationPopup(false)            // not needed
        setChapter_id(res.results.chapter_id)
        if (isMounted.current) {
          isMounted.current = false
        }
        // if novel is short story we have to redirect back to client side
        if(novelDetails?.is_novel === 3){
          if(window.Android){
            if(window.Android.handlePublishedClick){
              window.Android.handlePublishedClick(novelDetails?.book_id)
            }else{
              console.log("fn handlePublishedClick not found", novelDetails)
              history.replace('/home')
            }
          }else{
            history.replace('/home')
          }
          return
        }
        const isChapterSafe = await VerifyChapter(res?.results, status, url)
        if (!isChapterSafe) {
          setIsSubmitting(false)
          resetIsContentChanged(false)
          history.replace(
            `${menuItemObj.novels}/edit-chapter/${id}?chapter_id=${res.results.chapter_id}`
          )
          return
        }
         if (
           novelDetails?.share_feature_variant === 'B' &&
           saveMethod === 'is_share_feature'
         ) {
           setShowSharePopupOpen(true);
         }
        submitting_ref.current = false
        title_changed_ref.current = false
        // redirections
        if (flow === 'publish') {
          if (proceed_to_details) {
            history.replace(
              `${
                menuItemObj.novels
              }/edit-novel-details/${id}?publish_chapter_id=${
                res.results.chapter_id
              }&redirect_to_home=${redirect_to_home ? '1' : ''}&first_publish=1`
            )
            return
          }
          handlePublishChapterWithVoice(res.results.chapter_id, url, false)
          if (referrer === 'reader_screen')
            setAlertText('Congratulations! Your coins will be credited shortly')
          else setAlertText('Published Successfully')
          setAlertStyle({
            backgroundColor: '#E4F2E6',
            borderRadius: '50px',
            border: '1px solid #16A34A',
          })

          if (redirect_to_novel || referrer === 'reader_screen') {
            history.push(`${menuItemObj.novels}/id/${id}`)
          } else if (proceed_to_details) {
            history.replace(
              `${
                menuItemObj.novels
              }/edit-novel-details/${id}?publish_chapter_id=${
                res.results.chapter_id
              }&redirect_to_home=${redirect_to_home ? '1' : ''}&first_publish=1`
            )
            return
          } else if (pushToNovelForm) {
            history.replace(`${menuItemObj.novels}/edit-novel-details/${id}`)
          } else {
            is_published_ref.current = true
            handlePublishLog(startTime, res.results.chapter_id)
            setUserCalendarDate(userCalendarDate)
            if (res?.results?.from_incentive_value) {
              setPostPublishData({
                from_incentive_value: res.results?.from_incentive_value || 0,
                to_incentive_value: res.results?.to_incentive_value || 0,
                rem_streak_days: res.results?.rem_streak_days || 0,
                chapter_id: res.results?.chapter_id || '',
                daily_bonus_word_count_cap_variant:
                  res.results?.daily_bonus_word_count_cap_variant || 'A',
                isUgcBook:
                  novelDetails?.is_novel === 2 &&
                  novelDetails?.language === 'english',
                words_cap: res.results?.words_cap || 2000,
                today_word_count: res.results?.today_word_count || 0,
                chapter_bonus: res.results?.chapter_bonus,
              })
              togglePostPublishScreen(true)
            } else {
              props.history.goBack()
              setIsBack(true)
            }
          }
        } else {
          resetIsContentChanged(false)
          if (status === 'draft_auto_saved') {
            setAlertText('Content auto-saved! Keep writing')
            setAlertStyle({
              backgroundColor: '#E4F2E6',
              borderRadius: '50px',
              border: '1px solid #16A34A',
            })
          }
          get('/content_api/book.get_chapter_details', {
            params: {
              chapter_id: res.results.chapter_id,
              book_id: id,
              view: 'writers',
              is_novel: 1,
            },
          }).then((response) => {
            // setAlertText('Saved Successfully')
            setChapterDetails(response)
            latest_chapter_details.current = response
            setSavedChanges(true)
            setIsSubmitting(false)
            setIsBack(true)
            if (action === 'add-chapter') {
              changeUrlWithoutReload(null, `/shows/novels/edit-chapter/${id}?chapter_id=${res.results.chapter_id}&` + search.substr(1))
            }
          })
          setIsSubmitting(false)
          submitting_ref.current = false
        }
      } catch (error) {
        submitting_ref.current = false
        setIsSubmitting(false)
        if (novelDetails.content_editing && error.code === 400) {
          setRestrictDelete(true)
        } else if (status === 'draft_auto_saved') {
          setAlertText('Oops! Auto-save failed. Save your work manually')
          setAlertStyle({
            backgroundColor: '#FFE1E0',
            borderRadius: '50px',
            border: '1px solid #C1000066',
          })
        } else throw error
      }
    }
  }

  // when clicked on save above editor
  const handleVersionSave = (saveType = '') => {
    // if (checkIfWordCountIsZero()) return
    submitting_ref.current = true
    const repeated_words_count = repeatedWordsCount()
    handleNewEventLog(
      'chapter_editor',
      'novels_save_chapter_clicked',
      {
        route: window.location.pathname + window.location.search,
        button: 'save_chapter',
        entity_id: chapter_id || 'Null',
        entity_type: 'chapter',
      },
      user,
      novelDetails
    )
    // if only content or both content and title changed
    // and chapter can be published or draft
    if (
      isContentChanged(editorState) &&
      // title.length > 0 &&
      wordCount > 0 &&
      (!isSubmitting || submitting_ref.current)
    ) {
      setIsSubmitting(true)
      uploadFile({ status: 'draft', flow: 'save', saveMethod: saveType })
    } else if (chapter_id && title_changed_ref.current && title.length > 0) {
      // if only title is changed, not content
      post('/content_api/book.create_chapter?is_novel=1', {
        data: {
          book_id: id,
          chapter_id,
          word_count: wordCount,
          repeated_words_count,
          file_url: chapterDetails.result.file_url,
          chapter_title: title,
          status: 'draft',
          content_unchanged: 1,
          view: 'writers',
          program_type: novelDetails?.program_type || null,
        },
      })
        .then(async () => {
          setAlertText('Saved Successfully')
          if (
            novelDetails?.share_feature_variant === 'B' &&
            saveType === 'is_share_feature'
          ) {
            setShowSharePopupOpen(true);
          }
          title_changed_ref.current = false
          setIsSubmitting(false)
          setSavedChanges(true)
          submitting_ref.current = false;
        })
        .catch((err) => {
          setIsSubmitting(false)
          submitting_ref.current = false
          throw err
        })
    } else if (title.length > 0 && wordCount > 0) {
      if (
        novelDetails?.share_feature_variant === 'B' &&
        saveType === 'is_share_feature'
      ) {
        setShowSharePopupOpen(true);
      } else {
        setSavedChanges(true);
      }
    } else {
      if (
        novelDetails?.share_feature_variant === 'B' &&
        saveType === 'is_share_feature'
      ) {
        setShowSharePopupOpen(true);
      }
      return
    }
  }

  // called when click on publish
  const handleVersionPublish = async (userCalendarDate, popUpLoad = 0) => {
    submitting_ref.current = true
    if (checkIfWordCountIsZero()) return
    if (chapterDetails?.result?.status === 'published') {
      handleNewEventLog(
        'chapter_editor',
        'novels_chapter_updated',
        {
          route: window.location.pathname + window.location.search,
          button: 'udpate_chapter',
          entity_id: chapter_id || 'Null',
          entity_type: 'chapter',
        },
        user,
        novelDetails
      )
    } else {
      handleNewEventLog(
        'chapter_editor',
        novelDetails?.is_novel === 3 ? 'stories_editor_screen_publish' : 'novels_chapter_publish_clicked',
        {
          route: window.location.pathname + window.location.search,
          button: 'publish_chapter',
          entity_id: chapter_id || 'Null',
          entity_type: 'chapter',
        },
        user,
        novelDetails
      )
    }
    if (wordCount > 5000) {
      setHasPublishWarning(true)
      setAlertText('Please write below 5000 words and then publish the chapter')
      return
    }
    const repeated_words_count = repeatedWordsCount()
    // if (!popUpLoad) setDeclarationPopup(false)      // not needed

    let moveToStatus = 'published'
    if (proceed_to_details && novelDetails?.is_novel === 1)
      moveToStatus = 'draft'
    else if (
      novelDetails?.is_novel === 1 &&
      novelDetails.verification_required === 'True'
    )
      moveToStatus = 'review'

    // if content is changed
    if (
      isContentChanged(editorState) &&
      wordCount >= wordLimit &&
      (!isSubmitting || submitting_ref.current)
    ) {
      setIsSubmitting(true)
      uploadFile({ status: moveToStatus, userCalendarDate, flow: 'publish' })
    } else if (
      chapter_id &&
      (chapterDetails.result.status === 'draft' ||
        chapterDetails.result.status === 'draft_auto_saved') &&
      !isContentChanged(editorState) &&
      wordCount >= wordLimit &&
      !title_changed_ref.current
    ) {
      // only chapter status is changing from draft, not the content or title
      const now = new Date()
      const startTime = now.getTime()
      const chapterData = {
        chapter_id,
        status: moveToStatus,
        book_id: id,
        view: 'writers',
      }
      if (userCalendarDate)
        chapterData.schedule_time = moment(
          `${userCalendarDate} 06:00 AM`
        ).format('YYYY-MM-DD HH:mm:ss')

      put('/content_api/book.update_chapter_status?is_novel=1', {
        data: chapterData,
      })
        .then(async (res) => {
          let details = { ...chapterDetails.result, ...res?.results }
          const isChapterSafe = await VerifyChapter(details, moveToStatus)
          setIsSubmitting(false)
          if (!isChapterSafe) return
          handlePublishChapterWithVoice(
            chapter_id,
            chapterDetails.result?.file_url,
            true
          )
          if (redirect_to_novel || referrer === 'reader_screen') {
            history.push(`${menuItemObj.novels}/id/${id}`)
            return
          } else if (proceed_to_details) {
            history.push(
              `${
                menuItemObj.novels
              }/edit-novel-details/${id}?publish_chapter_id=${chapter_id}&redirect_to_home=${
                redirect_to_home ? '1' : ''
              }&first_publish=1`
            )
            return
          }
          setAlertText('Published Successfully')
          submitting_ref.current = false
          setSavedChanges(true)
          handlePublishLog(startTime, chapter_id)
          setUserCalendarDate(userCalendarDate)
          is_published_ref.current = true
          if (details?.from_incentive_value) {
            setPostPublishData({
              from_incentive_value: details?.from_incentive_value || 0,
              to_incentive_value: details?.to_incentive_value || 0,
              rem_streak_days: details?.rem_streak_days || 0,
              chapter_id: res.results?.chapter_id || '',
              daily_bonus_word_count_cap_variant:
                res.results?.daily_bonus_word_count_cap_variant || 'A',
              isUgcBook: novelDetails?.is_novel === 2,
              words_cap: res.results?.words_cap || 2000,
              today_word_count: res.results?.today_word_count || 0,
              chapter_bonus: res.results?.chapter_bonus,
            })
            togglePostPublishScreen(true)
          } else {
            history.replace(`/shows/novels/id/${id}?tab=published`)
            setIsBack(true)
          }
        })
        .catch((err) => {
          submitting_ref.current = false
          setIsSubmitting(false)
          throw err
        })
    } else if (
      chapter_id &&
      (chapterDetails.result.status === 'draft' ||
        chapterDetails.result.status === 'draft_auto_saved') &&
      !isContentChanged(editorState) &&
      wordCount >= wordLimit &&
      title_changed_ref.current
    ) {
      // when title is changed of a draft chapter and publishing it
      const now = new Date()
      const startTime = now.getTime()
      const chapterData = {
        book_id: id,
        chapter_id,
        word_count: wordCount,
        repeated_words_count,
        file_url: chapterDetails.result.file_url,
        chapter_title: title,
        status: proceed_to_details ? 'draft' : moveToStatus,
        view: 'writers',
        program_type: novelDetails?.program_type || null,
      }
      if (userCalendarDate)
        chapterData.schedule_time = moment(
          `${userCalendarDate} 06:00 AM`
        ).format('YYYY-MM-DD HH:mm:ss')
      post('/content_api/book.create_chapter?is_novel=1', {
        data: chapterData,
      })
        .then(async (res) => {
          const isChapterSafe = await VerifyChapter(
            res?.results,
            chapterData.status
          )
          if (!isChapterSafe) {
            setIsSubmitting(false)
            resetIsContentChanged(false)
            return
          }
          handlePublishChapterWithVoice(
            chapter_id,
            chapterDetails.result?.file_url,
            true
          )
          is_published_ref.current = true
          title_changed_ref.current = false
          if (proceed_to_details) {
            history.push(
              `${
                menuItemObj.novels
              }/edit-novel-details/${id}?publish_chapter_id=${chapter_id}&redirect_to_home=${
                redirect_to_home ? '1' : ''
              }`
            )
            return
          } else if (pushToNovelForm) {
            history.push(`${menuItemObj.novels}/edit-novel-details/${id}`)
            return
          }
          handlePublishLog(startTime, chapter_id)
          submitting_ref.current = false
          history.replace(`/shows/novels/id/${id}?tab=published`)
          setIsBack(true)
        })
        .catch((err) => {
          setIsSubmitting(false)
          submitting_ref.current = false
          throw err
        })
    }
  }

  const checkWordCount = () => {
    if (wordCount < 1000) {
      setHasPublishWarning(true)
      setAlertText('Please complete at least 1000 words to publish a chapter')
      handleEventLog('edit_chapter', 'Snack_fail_alert', {
        module_name: 'Publish',
        entity_type: 'chapter',
      })
      return false
    }
    if (wordCount > 5000) {
      setHasPublishWarning(true)
      setAlertText('Please write the chapter below 5000 words & update')
      handleEventLog('edit_chapter', 'Snack_fail_alert', {
        module_name: 'Publish',
        entity_type: 'chapter',
      })
      return false
    }
    if (
      chapterDetails && chapterDetails.result.status === 'published'
        ? title.split('-')[1]?.length < 2
        : title.length === 0
    ) {
      setHasPublishWarning(true)
      setAlertText('Please add title')
      handleEventLog('edit_chapter', 'Snack_fail_alert', {
        module_name: 'Publish',
        entity_type: 'chapter',
      })
      return false
    }
    return true
  }

  const handleStoryPublish = () => {
    handleNewEventLog(
      'chapter_editor',
      'stories_editor_screen_publish_confirmed',
      {
        route: window.location.pathname + window.location.search,
        button: 'publish_chapter',
        entity_id: chapter_id || 'Null',
        entity_type: 'chapter',
      },
      user,
      novelDetails
    )
    const storyContent = getPlainContent().replace(/\n/g, ' ').split(' ')
    let description = storyContent[0]
    for(let i=1;i<storyContent?.length;i++){
      if(description?.length > 150) break;
      description += ' ' + storyContent[i]
    }
    console.log("Descriptiion",description, description.length)
    post(`/content_api/book.create_book?is_novel=3`, {
      data: {
        ...novelDetails,
        book_title: title,
        description,
        is_disabled: 0
      },
    }).then(() => handleVersionPublish())
  }

  // when updating an already published chapter
  const handleVersionUpdate = () => {
    if (checkWordCount()) {
      handleNewEventLog(
        'chapter_editor',
        'novels_chapter_updated',
        {
          route: window.location.pathname + window.location.search,
          button: 'udpate_chapter',
          entity_id: chapter_id || 'Null',
          entity_type: 'chapter',
        },
        user,
        novelDetails
      )
      // if content is changed
      if (
        isContentChanged(editorState) &&
        wordCount >= wordLimit &&
        !isSubmitting
      ) {
        setAlertText('Updated Successfully')
        setIsSubmitting(true)
        uploadFile({ status: 'published', flow: 'publish' })
      } else if (
        title_changed_ref.current &&
        wordCount >= wordLimit &&
        !isSubmitting
      ) {
        // if only title is changed
        setIsSubmitting(true)
        if (checkIfWordCountIsZero()) return
        const repeated_words_count = repeatedWordsCount()
        post('/content_api/book.create_chapter?is_novel=1', {
          data: {
            book_id: id,
            chapter_id,
            word_count: wordCount,
            repeated_words_count,
            file_url: chapterDetails.result.file_url,
            chapter_title: title,
            status: chapterDetails.result.status,
            content_unchanged: 1,
            view: 'writers',
            program_type: novelDetails?.program_type || null,
          },
        })
          .then(() => {
            handlePublishChapterWithVoice(
              chapter_id,
              chapterDetails.result.file_url,
              true
            )
            setAlertText('Updated Successfully')
            setSavedChanges(true)
            setIsSubmitting(false)
            title_changed_ref.current = false
            props.history.goBack()
            setIsBack(true)
          })
          .catch((err) => {
            setIsSubmitting(false)
            if (novelDetails.content_editing && err.code === 400) {
              setRestrictDelete(true)
            } else throw err
          })
      }
    }
  }

  const uploadFile = ({ status, userCalendarDate, editorContent, flow, saveMethod }) => {
    //create a text file

    const content = editorContent ?? getContent(editorState)

    const file = new Blob([content], {
      type: 'text/plain;charset=utf-8',
    })

    // upload to s3
    const params = {
      title,
      tags: 'file',
      file_dir: id,
      image_extension: 'txt',
    }

    get(`/upload/get_presigned_url`, {
      params: params,
    })
      .then((response) => {
        const imageUrl = response.result[0]
        const awsFields = imageUrl.fields
        const prefix = imageUrl.url
        const suffix = imageUrl.s3_unique_key
        const formData = new FormData()
        formData.append('key', awsFields.key)
        formData.append('AWSAccessKeyId', awsFields.AWSAccessKeyId)
        formData.append(
          'x-amz-security-token',
          awsFields['x-amz-security-token']
        )
        formData.append('policy', awsFields.policy)
        formData.append('signature', awsFields.signature)
        formData.append('file', file)
        const cdn = 'https://d31b0xt3oaqqjh.cloudfront.net'
        post(prefix, {
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(() => {
            const url = `${cdn}/${id}/${suffix}`
            createChapterOrVersion(
              status,
              url,
              userCalendarDate,
              flow,
              saveMethod
            );
            // setSavedChanges(true);
          })
          .catch((error) => {
            submitting_ref.current = false
            setIsSubmitting(false)
            if (status === 'draft_auto_saved') {
              setAlertText('Oops! Auto-save failed. Save your work manually')
              setAlertStyle({
                backgroundColor: '#FFE1E0',
                borderRadius: '50px',
                border: '1px solid #C1000066',
              })
            } else throw error
          })
      })
      .catch((err) => {
        submitting_ref.current = false
        setIsSubmitting(false)
        if (status === 'draft_auto_saved') {
          setAlertText('Oops! Auto-save failed. Save your work manually')
          setAlertStyle({
            backgroundColor: '#FFE1E0',
            borderRadius: '50px',
            border: '1px solid #C1000066',
          })
        } else throw err
      })
  }

  const updateWordCount = (count) => {
    thresholds.forEach((threshold) => {
      if (count >= threshold && !onWordCountThresholdCrossed[threshold]) {
        setOnWordCountThresholdCrossed((prevState) => ({
          ...prevState,
          [threshold]: true,
        }))
        // Execute your logic when the word count crosses the threshold
        console.log(`Word count crossed ${threshold}`)
        handleNewEventLog(
          'chapter_editor',
          novelDetails?.is_novel === 3 
          ? (threshold === 1 ? 'stories_editor_screen_started_writing'
          : `stories_editor_screen_started_writing_${threshold}`)
          : `novels_chapter_${threshold}_words_written`,
          {
            route: window.location.pathname + window.location.search,
            module_name: 'chapter_editor_toolbar',
            entity_id: chapter_id || 'Null',
            entity_type: 'chapter',
          },
          user,
          novelDetails
        )
      }
    })
    if (count > 0 && count % 250 === 0) {
      setShowShareNotification(true)
    }
    setWordCount(count)
    latest_word_count.current = count
  }

  const handleTitleChange = (_title) => {
    setTitle(_title)
    title_ref.current = _title
    title_changed_ref.current = true
  }

  const onBack = () => {
    if (
      referrer === 'reader_screen' ||
      process === 'continue-writing' ||
      process === 'create-new'
    ) {
      if (window.Android && window.Android.closePage) {
        console.log('Executed closePage')
        window.Android.closePage()
        return
      }
    }
    if (isBack) {
      history.goBack()
    } else if (title_changed_ref.current && wordCount > 0) {
      setWarningPopup(true)
      return
    } else if (!isContentChanged(editorState)) {
      history.goBack()
    } else {
      setWarningPopup(true)
    }
  }

  const conditionForSaveAndPublish =
    action === 'add-chapter' ||
    (action === 'edit-chapter' &&
      chapterDetails &&
      (chapterDetails.result.status === 'draft' ||
        chapterDetails.result.status === 'draft_auto_saved'))

  const removeUnsavedChangesHandler = () => {
    setHasUnsavedChanges(false)
    const chapterObject = getChapterObject()
    if (chapterObject) {
      chapterObject.content = content
      setChapterObject(chapterObject)
    }
  }

  const addUnsavedChangesHandler = () => {
    setHasUnsavedChanges(false)
    const chapterObject = getChapterObject()
    if (chapterObject) {
      setContent(chapterObject.content)
      if (conditionForSaveAndPublish) {
        setIsSubmitting(true)
        setAlertText('Saved Successfully')
        uploadFile({
          status: 'draft',
          editorContent: chapterObject.content,
          flow: 'draft',
        })
      }
    }
  }

  const handleAddChapter = () => {
    handleEventLog('post_publish', 'button_click', {
      module_name: 'next_chapter_Write your next chapter',
      entity_id: showPostPublishData.chapter_id || '',
      entity_type: 'chapter',
    })
    props.history.push(
      `${menuItemObj.novels}/add-chapter/${
        novelDetails?.book_id
      }?proceed_to_details=&count=${parseInt(
        novelDetails.stats.published_chapter_count + 1
      )}`
    )
    window.location.reload()
  }

  const handlePublishClick = () => {
    if (title.length === 0) {
      setEmptyTitleError(true)
      return
    }
    // if chapter is already published, just update
    if (chapterDetails?.result?.status === 'published') {
      handleVersionUpdate()
      return
    }
    // if ugc show not configured and audio not selected
    if (
      (isUgcUser || isHindiUgcUser) &&
      novelDetails?.is_novel === 2 &&
      !novelDetails?.ugc_show_configured
    ) {
      if (!audioSelction){
        submitting_ref.current = true
        toggleVoiceSelectionPopup(true)
        return
      }
    }
    // if word count is more than 30k
    if (novelDetails?.word_count >= 30000) {
      if (conditionForSaveAndPublish) {
        handleNewEventLog(
          'chapter_editor',
          'novels_chapter_publish_planner_viewed',
          {
            route: window.location.pathname + window.location.search,
            module_name: 'chapter_editor_toolbar',
            entity_id: chapter_id || 'Null',
            entity_type: 'chapter',
          },
          user,
          novelDetails
        )
        toggleSchedulerPopup(true)
      } 
    }
    // if less than 30k and ugc first chapter
    else if(!chapter_id && novelDetails?.is_novel === 3){
      toggleConfirmStoryPopup(true)
    }else {
      handleVersionPublish()
    }
  }

  return (
    <Provider
      value={() =>
        !showPostPublishScreen ? (
          <EditorControls
            title={title}
            regex={/^Ch\s\d+\s-\s/}
            onBack={onBack}
            onTitleChange={handleTitleChange}
            chapterCount={novelDetails?.chapter_count}
            action={action}
            tab={tab}
            wordCount={wordCount}
            isUgcBook={novelDetails?.is_novel === 2}
            isShortStory={novelDetails?.is_novel === 3}
            undoActive={!isUndoEmpty(editorState)}
            redoActive={!isRedoEmpty(editorState)}
            handleUndo={() => onUndo(editorState, setEditorState)}
            handleRedo={() => onRedo(editorState, setEditorState)}
            setEmptyTitleError={setEmptyTitleError}
            emptyTitleError={emptyTitleError}
            showSharePopUpOpen={showSharePopUpOpen}
            setShowSharePopupOpen={setShowSharePopupOpen}
            user={user}
            wordLimit={wordLimit}
            showShareNotification={showShareNotification}
            setShowShareNotification={setShowShareNotification}
            isFirstChapterPublishBonus={
              (!!(novelDetails?.first_chapter_publish_bonus) ||
                novelDetails?.chapter_reward_limit) &&
              novelDetails?.boosting_word_count_exp_variant !== 'B' &&
              novelDetails?.boosting_word_count_exp_variant !== 'C'
            }
            boostingWordCountVariant={
              novelDetails?.boosting_word_count_exp_variant
            }
            isNavMenuOpen={isNavMenuOpen}
            chapterDetails={chapterDetails}
            setNavMenuOpen={setNavMenuOpen}
            novelDetails={novelDetails}
            chapter_id={chapter_id}
            handleShowRevision={() => {
              handleNewEventLog(
                'chapter_editor',
                'novels_chapter_version_history_clicked',
                {
                  route: window.location.pathname + window.location.search,
                  module_name: 'chapter_editor_toolbar',
                  entity_id: chapter_id || 'Null',
                  entity_type: 'chapter',
                },
                user,
                novelDetails
              );
              toggleShowVersion(true);
            }}
            showRevisionsIcon={chapter_id}
            toggleRevisionsSideDrawer={toggleShowVersion}
            actionButtons={{
              secondary: {
                label: 'Save',
                tooltip:
                  title.length === 0
                    ? 'Please type the title first'
                    : wordCount === 0
                    ? 'Please type the content'
                    : '',
                icon: SaveIcon,
                show: conditionForSaveAndPublish,
                enabled:
                  wordCount > 0 &&
                  !isSubmitting &&
                  (isContentChanged(editorState) || title_changed_ref.current),
                onClick: handleVersionSave,
                showSaveIcon:
                  chapterDetails && chapterDetails.result.status === 'published'
                    ? false
                    : true,
              },
              primary: {
                label:
                  chapterDetails && chapterDetails.result.status === 'published'
                    ? 'Update'
                    : 'Publish',
                tooltip: (
                  chapterDetails && chapterDetails.result.status === 'published'
                    ? title.split('-')[1]?.length < 2
                    : title.length === 0
                )
                  ? 'Please type the title first'
                  : wordCount < wordLimit
                  ? `Please type at least ${wordLimit} words to continue`
                  : wordCount > 5000
                  ? 'Maximum 5000 words allowed'
                  : '',
                // icon: CircleCheck,
                show: true,
                enabled:
                  wordCount >= wordLimit && wordCount <= 5000 && !isSubmitting,
                // enabled:
                //   (chapterDetails &&
                //   chapterDetails.result.status === 'published'
                //     ? title.split('-')[1]?.length > 1
                //     : title.length > 0) &&
                //   wordCount >= novelChapterWordCount &&
                //   wordCount <= 5000 &&
                //   !isSubmitting,
                onClick: handlePublishClick,
              },
            }}
          />
        ) : (
          <></>
        )
      }
    >
      <PrivatePage isProfileNameShown={false}>
        {!showPostPublishScreen ? (
          <EditorPageMainDiv>
            <RestrictDelete
              restrictDelete={restrictDelete}
              setRestrictDelete={setRestrictDelete}
            />
            <WarningPopup
              warningPopup={warningPopup}
              setWarningPopup={setWarningPopup}
              removeUnsavedChangesHandler={removeUnsavedChangesHandler}
              history={history}
            />
            <HasUnsavedChanges
              hasUnsavedChanges={hasUnsavedChanges}
              setHasUnsavedChanges={setHasUnsavedChanges}
              removeUnsavedChangesHandler={removeUnsavedChangesHandler}
              addUnsavedChangesHandler={addUnsavedChangesHandler}
            />
            <StoryConfirmPublishPopup
              confirmStoryPopup={confirmStoryPopup}
              toggleConfirmStoryPopup={toggleConfirmStoryPopup}
              handleStoryPublish={handleStoryPublish}
            />
            <VerifyForBadPublish
              verifyForBadPublish={verifyForBadPublish}
              setVerifyForBadPublish={setVerifyForBadPublish}
            />
            {(!!(novelDetails?.first_chapter_publish_bonus) ||
              novelDetails?.chapter_reward_limit) &&
              novelDetails?.boosting_word_count_exp_variant !== 'B' &&
              novelDetails?.boosting_word_count_exp_variant !== 'C' && (
                <IncentiveWrapper>
                  <IncentiveGoalBox
                    wordCount={wordCount}
                    publishBonus={
                      novelDetails?.first_chapter_publish_bonus ||
                      novelDetails?.chapter_reward_limit
                    }
                    wordCountCap={novelDetails?.chapter_word_count_cap}
                    chapter_id={chapter_id}
                  />
                </IncentiveWrapper>
              )}
            {(showVoiceSelectionPopup || showBackgroundMusicPopup) && (
              <VoiceSelection
                handlePublishClick={handlePublishClick}
                toggleBackgroundMusicPopup={toggleBackgroundMusicPopup}
                toggleVoiceSelectionPopup={toggleVoiceSelectionPopup}
                showVoiceSelectionPopup={showVoiceSelectionPopup}
                isBackgroundMusic={showBackgroundMusicPopup}
                isSubmitting={isSubmitting}
                voiceSelected={audioSelction}
                genre={novelDetails?.category_obj?.topic_name}
                updateVoiceSelection={(key, value) =>
                  updateAudioSelection({ ...audioSelction, [key]: value })
                }
                bookLanguage={novelDetails?.language}
              />
            )}
            {window.screen.width <= 600 && (
              <EditorControls
                title={title}
                regex={/^Ch\s\d+\s-\s/}
                wordCount={wordCount}
                onTitleChange={handleTitleChange}
                showTitle={true}
                isUgcBook={novelDetails?.is_novel === 2}
                chapterCount={novelDetails?.chapter_count}
                action={action}
                user={user}
                wordLimit={wordLimit}
                setEmptyTitleError={setEmptyTitleError}
                emptyTitleError={emptyTitleError}
                showSharePopUpOpen={showSharePopUpOpen}
                setShowSharePopupOpen={setShowSharePopupOpen}
                chapterDetails={chapterDetails}
                novelDetails={novelDetails}
                chapter_id={chapter_id}
                showShareNotification={showShareNotification}
                setShowShareNotification={setShowShareNotification}
                isFirstChapterPublishBonus={
                  (!!(novelDetails?.first_chapter_publish_bonus) ||
                    novelDetails?.chapter_reward_limit) &&
                  novelDetails?.boosting_word_count_exp_variant !== 'B' &&
                  novelDetails?.boosting_word_count_exp_variant !== 'C'
                }
                boostingWordCountVariant={
                  novelDetails?.boosting_word_count_exp_variant
                }
                isShortStory={novelDetails?.is_novel === 3}
                isNavMenuOpen={isNavMenuOpen}
                setNavMenuOpen={setNavMenuOpen}
              />
            )}
            {isLoading && !apiError && <Loader />}
            <GenericError
              show={apiError}
              onClose={() => toggleApiError(false)}
            />
            {!isLoading && (
              <TextEditor
                content={content}
                editorState={editorState}
                updateState={updateState}
                updateWordCount={updateWordCount}
                isUgcBook={novelDetails?.is_novel === 2}
                chapter_id={chapter_id}
                user={user}
                novelDetails={novelDetails}
                isFirstChapterPublishBonus={
                  (!!(novelDetails?.first_chapter_publish_bonus) ||
                    novelDetails?.chapter_reward_limit) &&
                  novelDetails?.boosting_word_count_exp_variant !== 'B' &&
                  novelDetails?.boosting_word_count_exp_variant !== 'C'
                }
                boostingWordCountVariant={
                  novelDetails?.boosting_word_count_exp_variant
                }
                setNavMenuOpen={setNavMenuOpen}
              />
            )}
            {!isLoading && showVersion && (
              <Revisions
                open={showVersion}
                close={() => {
                  fetchChapterDetails(); // called fetchChapterDetails to fetch the latest chapter details
                  toggleShowVersion(false);
                }}
                chapter_id={chapter_id}
                book_id={id}
                restoreSuccessCB={() => {
                  handleNewEventLog(
                    'chapter_editor',
                    'novels_chapter_old_version_restored',
                    {
                      route: window.location.pathname + window.location.search,
                      module_name: 'chapter_version',
                      entity_id: chapter_id || 'Null',
                      entity_type: 'chapter',
                    },
                    user,
                    novelDetails
                  );
                  fetchChapterDetails(novelDetails);
                }}
                {...props}
              />
            )}
            {schedulerPopup && (
              <ChapterScheduler
                toggleSchedulerPopup={toggleSchedulerPopup}
                novelDetails={novelDetails}
                chapterDetails={{ title, wordCount }}
                handleVersionPublish={handleVersionPublish}
                isSubmitting={isSubmitting}
                audioSelction={audioSelction}
                updateAudioSelection={updateAudioSelection}
              />
            )}
            {!isLoading && alertText && (savedChanges || hasPublishWarning) && (
              <AlertSnackBar
                container_styles={alertStyle}
                text_styles={{
                  fontSize: '12px',
                  fontWeight: '700',
                  textAlign: 'center',
                  width: '100%',
                }}
                bottomMobile="65px"
                mobileWidth="60%"
                text={alertText}
                close={() => {
                  if (savedChanges) setSavedChanges(false);
                  if (hasPublishWarning) setHasPublishWarning(false);
                }}
              />
            )}
          </EditorPageMainDiv>
        ) : togglePostPublishScreen &&
          showPostPublishData?.chapter_bonus ? (
          <PostPublishScreenVariantB
            bookId={novelDetails.book_id}
            handleBack={handleBackForPostPublishScreen}
            showPostPublishData={showPostPublishData}
            publishDate={
              userCalendarDate ||
              `${new Date().getDate()}-${
                months[new Date().getMonth()]
              }-${new Date().getFullYear()}`
            }
            onAddChapter={() => handleAddChapter()}
          />
        ) : (
          <PostPublishScreen
            book={novelDetails}
            handleBack={handleBackForPostPublishScreen}
            showPostPublishData={showPostPublishData}
            publishDate={
              userCalendarDate ||
              `${new Date().getDate()}-${
                months[new Date().getMonth()]
              }-${new Date().getFullYear()}`
            }
          />
        )}
      </PrivatePage>
    </Provider>
  );
}
